module.exports = __webpack_public_path__ + "static/media/compass.25b6039c.png";